import React, { Component } from 'react';
import FakeData from '.././fake-data';
import { Link } from 'react-router-dom';

import Geosuggest from 'react-geosuggest';

import './GroupEvents.css';
import { EventViewSplitPane, EditEventModal } from './Event'
import { Modal, ComboBox, PublicityPicker, PhonePicker, ConfirmModal, EmptyState, InputField } from './Common';
import { CreateNormalEvent } from '.././pages/Home';
import { EvtFilterCal } from '../pages/Events';

export default class GroupEvents extends Component {
    constructor(p) {
        super(p)
        this.state = {
            activeTab: this.props.isCreate ? "Events" : "Events",
            userTabs: ["Events", "Calender"],
            isAdding: false,
            filter: ""
        }
    }

    onChange = (e) => {
        this.setState({ filter: e.target.value });
    }

    filterData = (isPast) => {
        const { filter } = this.state;
        const { events } = this.props;
        FakeData.listify(events).sort((a, b) => {
            return a.timestamp - b.timestamp;
        })
        const list = FakeData.listify(events).filter((item) => {
            return (item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1 && item.isPast === isPast);
        })

        return list;
    }

    render() {
        const { profile, isAdmin, users, events, isCreate } = this.props;
        const { activeTab, filter, isAdding } = this.state;
        const _that = this;
        const _isMember = profile.isMember || isAdmin;

        return (
            <div className="default-view" style={{ backgroundColor: "#fff", marginTop: this.props.isPage ? 0 : "10px", paddingBottom: "20px" }}>
                <div className="view-with-tabs">
                    {!isCreate &&
                        <div className="view-with-tabs-head">
                            {
                                this.state.userTabs.map((item, i) => {
                                    const count = FakeData.listify(events).length
                                    return (
                                        <div key={i} className={(item === this.state.activeTab) ? "view-with-tabs-head-item group-mem-count-holder active" : "view-with-tabs-head-item group-mem-count-holder"} onClick={() => this.setState({ activeTab: item, filter: "" })}>
                                            {item}
                                            {item !== "Calender" && <span className="group-mem-count">{FakeData.shortDigit(count, "").text}</span>}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    }

                    <div className="view-with-tabs-body">
                        {activeTab !== "Calender" &&
                            <div className="group-members-view-list-filter">
                                <div className="group-members-view-list-filter-search">
                                    <input value={filter} placeholder="Search event" onChange={this.onChange.bind(this)} />
                                    <i className="material-icons">search</i>
                                </div>
                                {(_isMember) && <span style={{ marginRight: "10px" }}>or</span>}
                                {(_isMember) && <button onClick={() => this.setState({ isAdding: true })}>Create an Event</button>}
                            </div>
                        }
                        {activeTab === "Events" &&
                            <div style={{ width: "100%" }}>
                                {FakeData.listify(events).length > 1000 &&
                                    <div className="group-event-list">

                                    </div>
                                }
                                <div className="group-event-list">
                                    <div className="group-event-list-title">Upcoming Events</div>
                                    {
                                        this.filterData(false).map((item, i) => {
                                            return (
                                                <EventItem key={i} event={item} isAdmin={profile.isAdmin} isPast={false} />
                                            )
                                        })
                                    }
                                    <EmptyState isShown={(this.filterData(false).length === 0) ? true : false} text="No Events were found!" icon="event" />
                                </div>
                                <div className="group-event-list">
                                    <div className="group-event-list-title">Past Events</div>
                                    {
                                        this.filterData(true).map((item, i) => {
                                            return (
                                                <EventItem key={i} event={item} isAdmin={profile.isAdmin} isPast={true} />
                                            )
                                        })
                                    }
                                    <EmptyState isShown={(this.filterData(true).length === 0) ? true : false} text="No Events were found!" icon="event" />
                                </div>
                            </div>
                        }
                        {activeTab === "Calender" &&
                            <div style={{ width: "100%" }}>
                                <EventCalenderView events={events} isAdmin={profile.isAdmin} />
                            </div>
                        }
                        {this.i && <EmptyState isShown={(FakeData.listify([]).length === 0) ? true : false} text="No Events were found!" icon="event" />}
                    </div>
                </div>
                {isAdding &&
                    <CreateNormalEvent toId={profile.id} toType={this.props.isPage ? this.props.pageType : "Q"} users={profile.members} isOpen={isAdding} onClose={(data) => {
                        this.setState({ isAdding: false });
                    }} />
                }
            </div>
        );
    }
}

class EventItem extends React.Component {

    getStatus = (status) => {
        const { event } = this.props
        const list = FakeData.listify(event.invites).filter((item) => {
            return item.status == status;
        })

        return list;
    }

    getYou = () => {
        const { event } = this.props
        const list = FakeData.listify(event.invites).filter((item) => {
            return item.user.id === FakeData.getData("yoo").id;
        })

        if (list.length === 0) {
            return false;
        }

        return list[0];
    }

    render = () => {
        const { isAdmin, isPast, event } = this.props
        const hrs = FakeData.toMyTimezone(event.timestamp * 1000).getHours();
        const _hrs = hrs < 10 ? "0" + hrs : hrs;
        const min = FakeData.toMyTimezone(event.timestamp * 1000).getMinutes();
        const _min = min < 10 ? "0" + min : min;
        const time = _hrs + ":" + _min + (hrs > 11 ? "PM" : "AM");
        return (
            <div className="group-event-item">
                <div className="group-event-item-date">
                    <span style={{ color: (isPast) ? "#90949C" : "" }}>{(event.month !== event.e_month) ? FakeData.months[event.month - 1].substring(0, 3) + " - " + FakeData.months[event.e_month - 1].substring(0, 3) : FakeData.months[event.month - 1].substring(0, 3)}</span>
                    <span style={{ color: (isPast) ? "#90949C" : "" }}>{event.isOneDay ? event.day : event.day + " - " + event.e_day}</span>
                </div>
                <div className="group-event-item-details">
                    <div className="group-event-item-details-title">{event.name.capitalize()}</div>
                    <div className="group-event-item-details-audience">{time} - {this.getStatus("yes").length} going, {this.getStatus("interested").length} Interested</div>
                </div>
                <div className="group-event-item-details-venue">{event.place}</div>
                {!isPast &&
                    <div className="group-event-item-details-actions">
                        {!isAdmin &&
                            <div className="group-event-item-details-action has-drop-down" ref="options" tabIndex={0}>
                                <i className="material-icons">done</i>
                                <span>Going</span>
                                <div className="group-event-item-details-action-drop-down">
                                    <span style={{ color: "#000" }}>Going</span>
                                    <span style={{ color: "#000" }}>Maybe</span>
                                    <span style={{ color: "#000" }}>Not Going</span>
                                </div>
                            </div>
                        }
                        <div className="group-event-item-details-action">
                            <i className="material-icons">share</i>
                            <span>Share</span>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export class EventCalenderView extends Component {
    constructor(props) {
        super(props);
        this.date = new Date();
        this.date.setMinutes(this.date.getMinutes() - this.date.getTimezoneOffset());
        this.state = {
            isDay: false,
            events: [],
            months: FakeData.months,
            days: FakeData.days,
            current: {
                date: this.date.getDate(),
                year: this.date.getFullYear(),
                month: FakeData.months[this.date.getMonth()],
                index: this.date.getMonth(),
                lastDay: this.getLastDay(this.date.getDate(), this.date.getMonth())
            },
            dates: this.genDays(this.date.getFullYear(), this.date.getMonth() + 1),
            date: ""
        }
    }

    getLastDay = (year, month) => {
        var year = this.date.getFullYear()
        var date = new Date(year, this.date.getMonth() + 1, 0)
        date.setMinutes(date.getMinutes() - date.getTimezoneOffset())
        return date.getDate()
    }

    prev = (int) => {
        if (this.state.current.index === 0) {
            var year = parseInt(this.state.current.year) - 1
            this.setState({
                current: {
                    date: this.date.getDate(),
                    year: year,
                    month: FakeData.months[11],
                    index: 11,
                    lastDay: this.getLastDay(year, 12)
                },
                dates: this.genDays(year, 13)
            })
        } else {
            var year = this.state.current.year
            this.setState({
                current: {
                    date: this.date.getDate(),
                    year: year,
                    month: FakeData.months[int],
                    index: int,
                    lastDay: this.getLastDay(year, int)
                },
                dates: this.genDays(year, int + 1)
            })
        }
    }

    next = (int) => {
        if (this.state.current.index === 11) {
            var year = parseInt(this.state.current.year) + 1
            this.setState({
                current: {
                    date: this.date.getDate(),
                    year: year,
                    month: FakeData.months[0],
                    index: 0,
                    lastDay: this.getLastDay(year, 1)
                },
                dates: this.genDays(year, 2)
            })
        } else {
            var year = this.state.current.year
            this.setState({
                current: {
                    date: this.date.getDate(),
                    year: year,
                    month: FakeData.months[int],
                    index: int,
                    lastDay: this.getLastDay(year, int)
                },
                dates: this.genDays(year, int + 1)
            })
        }
    }

    genDays = (year, month, isUpdate) => {
        var date = new Date(year, month, 0)
        date.setMinutes(date.getMinutes() - date.getTimezoneOffset())
        var firstDay = new Date(year, month - 1, 1)
        firstDay.setMinutes(firstDay.getMinutes() - firstDay.getTimezoneOffset())
        //var endDay = new Date(year, month + 1, 1)
        //endDay.setMinutes(endDay.getMinutes() - endDay.getTimezoneOffset())
        var startDay = firstDay.getDay()
        //var _endDay = endDay.getDay();
        //console.log(_endDay)
        const arr = []
        for (let i = 0; i < date.getDate() + startDay; i++) {
            if (i < startDay) {
                arr.push({
                    id: null,
                    value: i,
                    year: year,
                    month: month
                })
            } else {
                const bool = Boolean(isUpdate)
                const events = []
                arr.push({
                    id: i,
                    value: i - startDay,
                    year: year,
                    month: month
                })
            }

        }



        return arr
    }

    getEventsForDate = (year, month, day) => {
        const list = [];
        const { events } = this.props
        events.map((item, i) => {
            if (item.year === year && item.month === month && item.day === day) {
                list.push(item)
            }
        })

        return list
    }

    getEventsForMonth = (month) => {
        const list = [];
        const { events } = this.props
        events.map((item, i) => {
            if (item.month === month || item.e_month === month) {
                list.push(item)
            }
        })

        return list
    }

    getActualDays = () => {
        const { isDay, dates } = this.state;
        const list = dates.filter((item) => {
            return item.id !== null;
        })

        return list;
    }

    render = () => {
        const { isDay, dates } = this.state;
        const { isAdmin, isCalendar } = this.props;
        return (
            <div className={isDay ? "evt-cal-view" : "evt-cal-view"}>
                {!isCalendar &&
                    <div className={"evt-cal-ch-view"}>
                        <div className={isDay ? "active" : ""} onClick={() => this.setState((state, props) => ({ isDay: true }))}><i className="material-icons">format_list_bulleted</i> <span>Day</span></div>
                        <div className={!isDay ? "active" : ""} onClick={() => this.setState((state, props) => ({ isDay: false }))}><i className="material-icons">event</i> <span>Month</span></div>
                    </div>
                }

                {!isDay &&
                    <div className={"evt-cal-m-view"}>
                        <div className="evt-cal-m-head">
                            <i className="icon left" onClick={() => {
                                this.prev(this.state.current.index - 1)
                            }}></i>
                            <span>{this.state.current.month + ", " + this.state.current.year}</span>
                            <i className="icon right" onClick={() => {
                                this.next(this.state.current.index + 1)
                            }}></i>
                        </div>
                        <div className="evt-cal-m-days">
                            {
                                FakeData.days.map((item, i) => {
                                    return (
                                        <div className="evt-cal-m-day" key={item}>
                                            {item}
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className="evt-cal-m-dates">
                            {
                                dates.map((item, i) => {
                                    return (
                                        <EventMonthDay isAdmin={isAdmin} isDummy={false} item={item} events={this.getEventsForDate(item.year, item.month, item.value + 1)} key={i} />
                                    )
                                })
                            }
                            <EventMonthDay isAdmin={isAdmin} isDummy={true} />
                        </div>
                    </div>
                }

                {isDay &&
                    <div className={"evt-cal-d-view"}>
                        {
                            FakeData.months.map((item, i) => {
                                return (
                                    <EventListDate isAdmin={isAdmin} key={i} month={item} events={this.getEventsForMonth(i + 1)} />
                                )
                            })
                        }
                    </div>
                }
            </div>
        )
    }
}

export class EventAttandence extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeFilter: "",
            activeView: "Attendence",
            activeEvent: this.props.events[0]?this.props.events[0]:{invites:[]},
            activeTeam: "",
            offset: 0,
            limit: 4,
            date: {
                start: "",
                end: ""
            }
        }
    }

    next = () => {
        const { events } = this.props;
        if (events.length < 5) {
            return;
        }

        const start = this.state.offset
        const end = this.state.limit
        if (end === events.length) {
            return
        }
        const _offset = start - 1
        const _limit = end - 1
        this.setState({
            offset: _offset,
            limit: _limit
        });
    }

    prev = () => {
        const { events } = this.props;
        if (events.length < 5) {
            return;
        }

        const start = this.state.offset
        const end = this.state.limit
        if (start === 0) {
            return
        }
        const _offset = start - 1
        const _limit = end - 1
        this.setState({
            offset: _offset,
            limit: _limit
        });
    }

    onEventSelect(event) {
        this.setState({
            activeEvent: event
        });
    }

    getEventAttendence = (event, user) => {
        if (!event) {
            return false;
        } else {
            const _users = FakeData.listify(event.invites).filter((invite) => {
                return invite.id === user.id;
            });
            return _users.length > 0 ? { event, user: _users[0] } : false
        }
    }

    getEventAttendences = (events = [], user) => {
        const _atts = [];
        events.forEach((item, i) => {
            _atts.push(this.getEventAttendence(item, user))
        })

        return _atts;
    }

    render = () => {
        const { activeFilter, activeView, activeEvent, offset, limit, date, activeTeam } = this.state;
        const { events, profile, isParent, isAdmin } = this.props;
        const hasDate = date.start === "" ? false : true;
        let _date = "Choose date";
        if (hasDate) {
            const sArr = date.start.split(" ");
            const eArr = date.end.split(" ");
            _date = sArr[0] + "/" + sArr[1] + "/" + sArr[2] + " to " + eArr[0] + "/" + eArr[1] + "/" + eArr[2]
        }
        const _activeEvent = (!activeEvent) ? (events[0] ? events[0] : false) : false;
        const _events = hasDate ? FakeData.listify(events).filter((event) => {
            const _thisDate = new Date(event.date);
            const _startDate = new Date(date.start);
            const _endDate = new Date(date.end);
            return event.type !== "Normal" && (_thisDate.getTime() >= _startDate.getTime() || _thisDate.getTime() <= _endDate.getTime());
        }).filter((event, i) => {
            if (activeFilter === "") {
                return event.type !== "Normal" && (i <= offset && i <= limit);
            } else {
                return event.type === activeFilter && (i <= offset && i <= limit);;
            }
        }) : FakeData.listify(events).filter((event) => {
            return event.type !== "Normal";
        }).filter((event, i) => {
            if (activeFilter === "") {
                return event.type !== "Normal" && (i <= offset && i <= limit);
            } else {
                return event.type === activeFilter && (i <= offset && i <= limit);;
            }
        });

        return (
            <div className="event-attandence-view">
                <div className="event-attandence-view-filters triple-split" ref={"settingsCtx"} tabIndex={0}>
                    <InputField label={"Select View"}>
                        <select className="normal-input" style={{ height: "28px" }} onChange={(e) => {
                            this.setState({ activeView: e.target.value });
                        }}>
                            {
                                ["Attendence", "Availability"].map((item, i) => {
                                    return (
                                        <option key={i} value={item === "All" ? "" : item}>{item}</option>
                                    )
                                })
                            }
                        </select>
                    </InputField>

                    <InputField label={"Event Type"}>
                        <select className="normal-input" style={{ height: "28px" }} onChange={(e) => {
                            this.setState({ activeFilter: e.target.value });
                        }}>
                            {
                                ["All", "Training", "Social", "Meeting", "Game"].map((item, i) => {
                                    return (
                                        <option key={i} value={item === "All" ? "" : item}>{item}</option>
                                    )
                                })
                            }
                        </select>
                    </InputField>
                    <InputField label={"Select Team"}>
                        <select className="normal-input" style={{ height: "28px" }} onChange={(e) => {
                            this.setState({ activeTeam: e.target.value });
                        }}>
                            <option value={""}>{"All"}</option>
                            {
                                FakeData.listify(this.props.teams).map((item, i) => {
                                    return (
                                        <option key={i} value={item.name}>{item.name}</option>
                                    )
                                })
                            }
                        </select>
                    </InputField>
                    <InputField label={"Date"} tabIndex={0} style={{ position: "relative" }}>
                        <span className="normal-input" style={{ height: "28px" }}>{_date}</span>
                        <EvtFilterCal parent={this.refs.settingsCtx} onDatePicked={(s, e) => {
                            date.end = e;
                            date.start = s;
                            this.setState({ date });
                        }} />
                    </InputField>
                </div>
                <div className="event-attandence-view-slider">
                    <i className="icon left" onClick={this.prev.bind(this)}></i>
                    <div className="event-attandence-view-slider-ctx">
                        {
                            FakeData.listify(events).filter((event) => {
                                return event.type !== "Normal";
                            }).filter((event) => {
                                if (activeFilter === "") {
                                    return event.type !== "Normal";
                                } else {
                                    return event.type === activeFilter;
                                }
                            }).map((item, i) => {
                                return (
                                    <div key={i}>

                                    </div>
                                )
                            })
                        }
                        {
                            FakeData.getDummy(5).map((item, i) => {
                                return (
                                    <_AttandenceSliderItem key={i} event={_events[i] ? _events[i] : false} itemActive={(_activeEvent.id && _events[i]) && _events[i].id === _activeEvent.id ? true : false} canEdit={isAdmin} key={i} onEventSelect={this.onEventSelect.bind(this)} />
                                )
                            })
                        }
                    </div>
                    <i className="icon right" style={{ pointer: "cursor" }} onClick={this.next.bind(this)}></i>
                </div>
                <div className="event-attandence-view-body">
                    {FakeData.listify(activeEvent.invites).filter((user) => {
                        return user.id === profile.id;
                    }).length === 0 && isParent &&
                        <EmptyState isShown={true} text={"No User Found"} style={{ width: "100%", height: "100%" }} icon={"person"} />
                    }
                    {FakeData.listify(activeEvent.invites).length === 0 && !isParent &&
                        <EmptyState isShown={true} text={"No Users Found"} style={{ width: "100%", height: "100%" }} icon={"person"} />
                    }
                    {isParent &&
                        FakeData.listify(activeEvent.invites).filter((user) => {
                            return user.id === profile.id;
                        }).map((item, i) => {
                            return (
                                <EventAttandenceItem attendence={this.getEventAttendences(_events, item)} key={i} user={item} view={activeView} />
                            );
                        })
                    }
                    {!isParent &&
                        FakeData.listify(activeEvent.invites).map((item, i) => {
                            return (
                                <EventAttandenceItem attendence={this.getEventAttendences(_events, item)} key={i} user={item} view={activeView} />
                            );
                        })
                    }
                </div>
            </div>
        )
    }
}

class _AttandenceSliderItem extends Component {
    state = {
        isEditting: false
    }

    setStatus = (status) => {

    }

    getStatus = (status) => {
        const { event } = this.props
        const list = FakeData.listify(event.invites).filter((item) => {
            return item.status == status;
        })

        return list;
    }

    render = () => {
        const { isEditting } = this.state;
        const { event, view, status, canEdit, itemActive } = this.props;

        if (!event) {
            return (
                <div className="event-attandence-slider-item" />
            )
        }

        const _name = FakeData.nullify(event.name)

        return (
            <div className={(itemActive) ? "event-attandence-slider-item active" : "event-attandence-slider-item"} onClick={() => this.props.onEventSelect(event)}>
                <span>{_name.substring(0, 30)}{_name.length > 30 ? "..." : ""}</span>
                <span>{event.date}</span>
                {!event.isGame &&
                    <div className="hori-event-indicators">
                        <span>+{this.getStatus("no").length}</span>
                        <span>+{this.getStatus("yes").length}</span>
                        <span> +{this.getStatus("maybe").length}</span>
                    </div>
                }
                {!event.isGame && canEdit &&
                    <button onClick={() => {
                        this.setState({
                            isEditting: true
                        });
                    }}>Edit</button>
                }
                {isEditting &&
                    <EditEventModal eventToType={event.user.type} eventToID={event.user.id} isOpen={isEditting} event={event} onClose={() => {
                        this.setState({
                            isEditting: false
                        });
                    }} />
                }
            </div>
        )
    }
}

class EventAttandenceItem extends Component {
    state = {

    }

    render = () => {
        const { } = this.state;
        const { user, view, attendence } = this.props;
        return (
            <div className="event-attandence-view-body-item">
                <span>{user.user.name}</span>
                <div>
                    {
                        FakeData.getDummy(5).map((item, i) => {
                            const _user = attendence[i] ? attendence[i].user : false;
                            const _event = attendence[i] ? attendence[i].event : false;
                            return (
                                <_AttandenceItem user={_user} view={view} event={_event} attendence={attendence} status={view === "Attendence" ? _user.attend : _user.status} key={i} hasInvite={attendence[i]} />
                            )
                        })
                    }
                </div>
            </div>
        )
    }
}

class _AttandenceItem extends Component {
    state = {

    }

    setStatus = (status) => {
        const { user, view, event, hasInvite } = this.props;
        if (!hasInvite) {
            return false;
        }

        console.log("setting ", view, status);
        const url = "/updateTable.php?auth0&ref=additionalinvites";

        if (view === "Attendence") {
            const data = {
                data: { Attended: status },
                query: "EventID='" + event.id + "' AND UserID='" + user.id + "' AND UserType='" + user.type + "'",
                user: { id: FakeData.getData("yoo").id, type: "F" },
                userTo: { id: event.id, type: "E" }
            }

            FakeData.post(url, data, {
                success(res) {
                    if (res.error) {
                        FakeData.alert("Coundn't update data!");
                    } else {

                    }
                },
                error(err) {
                    FakeData.alert("Coundn't update data!");
                    //<Developed by="" website="" facebook="" twitter="" instagram="" google-plus=""/>
                }
            }, true, "", (t) => { })
        } else {
            const data = {
                data: { Status: status },
                query: "EventID='" + event.id + "' AND UserID='" + user.id + "' AND UserType='" + user.type + "'",
                user: { id: FakeData.getData("yoo").id, type: "F" },
                userTo: { id: event.id, type: "E" }
            }

            FakeData.post(url, data, {
                success(res) {
                    if (res.error) {
                        FakeData.alert("Coundn't update data!");
                    } else {

                    }
                },
                error(err) {
                    FakeData.alert("Coundn't update data!");
                    //<Developed by="" website="" facebook="" twitter="" instagram="" google-plus=""/>
                }
            }, true, "", (t) => { })
        }

    }

    render = () => {
        const { } = this.state;
        const { user, view, status, attendence, hasInvite, event } = this.props;
        if (!hasInvite) {
            return (
                <div className="event-attandence-view-item" />
            )
        }
        return (
            <div className="event-attandence-view-item">
                {status === "no" && view !== "Attendence" && <img src={"images/mark_yes.svg"} style={{ opacity: 0.2 }} onClick={() => this.setStatus("yes")} />}
                <img src={"images/mark_no.svg"} style={{ opacity: status === "no" ? 1 : 0.2 }} onClick={() => this.setStatus("no")} />
                {status === "yes" && view !== "Attendence" && <img src={"images/mark_yes.svg"} style={{ opacity: status === "yes" ? 1 : 0.2 }} onClick={() => this.setStatus("yes")} />}
                {view === "Attendence" && <img src={"images/mark_yes.svg"} style={{ opacity: status === "yes" ? 1 : 0.2 }} onClick={() => this.setStatus("yes")} />}
                {view !== "Attendence" && <img src={"images/Wave_Dash1.svg"} style={{ opacity: status === "maybe" ? 1 : 0.2 }} onClick={() => this.setStatus("maybe")} />}
                {status === "maybe" && view !== "Attendence" && <img src={"images/mark_yes.svg"} style={{ opacity: 0.2 }} onClick={() => this.setStatus("yes")} />}
            </div>
        )
    }
}

class EventMonthDay extends Component {
    constructor(props) {
        super(props);
        this.date = new Date();
        this.date.setMinutes(this.date.getMinutes() - this.date.getTimezoneOffset());
        this.state = {
            index: 0,
            filters: ["Game", "Social", "Meeting", "Training", "Normal"],
            className: ""
        }
    }

    getFiltered(arr, _list) {
        const list = Array();
        FakeData.listify(_list).forEach((item, i) => {
            if (FakeData.inArray(item.type, FakeData.listify(arr))) {
                list.push(item)
            }
        })
        return list;
    }

    render = () => {
        const { item, events, isDummy, isAdmin } = this.props
        if (isDummy) {
            return (
                <div className={"evt-cal-m-date dummy"}></div>
            )
        }
        const { index, filters, className } = this.state
        const today = this.date.getDate() - 1;
        const y = this.date.getFullYear()
        const m = this.date.getMonth() + 1;
        const _events = this.getFiltered(filters, events)
        return (
            <div
                data-value={item.value + 1}
                className={(item.id === null) ? "evt-cal-m-date past" : (events.length > 0) ? "evt-cal-m-date has-events" : "evt-cal-m-date"}
                tabIndex={0}>
                {item.id !== null && <span className={(item.value === today && item.year === y && item.month === m) ? "evt-cal-m-date-now" : ""}>{item.value + 1}</span>}
                {item.id !== null &&
                    <div className="evt-cal-m-date-e-list">
                        {
                            _events.map((item, i) => {
                                return (
                                    <div key={i} style={{ background: item.color, color: FakeData.getLuminance(item.color) }}>
                                        {item.name.capitalize()}
                                    </div>
                                )
                            })
                        }
                    </div>
                }
                {(_events.length > 0 && item.id !== null) &&
                    <div className="event-widget-day-pop">

                        <div className={"event-widget-day-pop-head " + className}>
                            <i className="material-icons">event</i>
                            <div dangerouslySetInnerHTML={{ __html: "<marquee scrollamount=\"2\">" + _events[index].name + "</marquee><span>" + _events[index].type + "</span>" }} />
                            <div className="notices-badge" style={{ marginTop: "8px" }}>
                                {(this.getFiltered(["Social", "Meeting"], events).length > 0 && events.length > 1) &&
                                    <span className="events" style={{ margin: "0px 2px" }} onClick={() => {
                                        this.setState({
                                            filters: ["Social", "Meeting"],
                                            className: "events",
                                            index: 0
                                        });
                                    }}>{this.getFiltered(["Social", "Meeting"], events).length}</span>
                                }
                                {(this.getFiltered(["Training"], events).length > 0 && events.length > 1) &&
                                    <span className="_training" style={{ margin: "0px 2px" }} onClick={() => {
                                        this.setState({
                                            filters: ["Training"],
                                            className: "_training",
                                            index: 0
                                        });
                                    }}>{this.getFiltered(["Training"], events).length}</span>
                                }
                                {(this.getFiltered(["Game"], events).length > 0 && events.length > 1) &&
                                    <span className="games" style={{ margin: "0px 2px" }} onClick={() => {
                                        this.setState({
                                            filters: ["Game"],
                                            className: "",
                                            index: 0
                                        });
                                    }}>{this.getFiltered(["Game"], events).length}</span>
                                }
                                {this.getFiltered(["Game", "Social", "Meeting", "Training"], events).length > 1 &&
                                    <span className="all" style={{ margin: "0px 2px" }} onClick={() => {
                                        this.setState({
                                            filters: ["Game", "Social", "Meeting", "Training"],
                                            className: "",
                                            index: 0
                                        });
                                    }}>{this.getFiltered(["Game", "Social", "Meeting", "Training"], events).length}</span>
                                }
                            </div>
                        </div>
                        {_events.length > 1 &&
                            <div className={"event-widget-day-pop-ctrl " + className}>
                                {
                                    _events.map((item, i) => {
                                        return (
                                            <span className={(index === i) ? "active" : ""} key={item.id} onClick={() => this.setState({ index: i })} />
                                        )
                                    })
                                }
                            </div>
                        }
                        <div className="event-widget-day-pop-body">
                            <div>
                                <span>Venue</span>
                                <span>{_events[index].place}</span>
                            </div>
                            <div>
                                <span>Date</span>
                                <span>{_events[index].date}</span>
                            </div>
                            <div>
                                <span>Time</span>
                                <span>{(isNaN(FakeData.toMyTimezone(_events[index].fullTimestamp).getHours())) ? "not set" : FakeData.toMyTimezone(_events[index].fullTimestamp).getHours() + ":" + FakeData.toMyTimezone(_events[index].fullTimestamp).getMinutes() + ((FakeData.toMyTimezone(_events[index].fullTimestamp).getHours() > 11) ? "PM" : "AM")}</span>
                            </div>
                        </div>

                    </div>
                }
            </div>
        )
    }

}

class EventListDate extends Component {
    constructor(props) {
        super(props);
        this.date = new Date();
        this.date.setMinutes(this.date.getMinutes() - this.date.getTimezoneOffset());
        this.state = {
            year: this.date.getFullYear(),
            index: 0,
            filters: ["Social", "Meeting", "Training", "Normal"],
            className: ""
        }
    }

    getEvents() {
        const { month, events } = this.props
        const { index, filters, className, year } = this.state
        const list = FakeData.listify(events).filter((item) => {
            return item.year === year;
        })
        return list;
    }

    render = () => {
        const { month, events, isAdmin } = this.props
        const { index, filters, year } = this.state
        const today = this.date.getDate() - 1;
        const y = this.date.getFullYear()
        const m = this.date.getMonth() + 1;
        const _events = this.getEvents()
        if (events.length === 0) {
            return null;
        }

        _events.sort((a, b) => {
            return a.timestamp - b.timestamp;
        })

        return (
            <div className="evt-cal-dm-view">
                <div className="evt-cal-dm-view-head">
                    <i className="icon left" onClick={() => this.setState((state, props) => { return { year: state.year - 1 } })}></i>
                    <span>{month}, {year}</span>
                    <i className="icon right" onClick={() => this.setState((state, props) => { return { year: state.year + 1 } })}></i>
                </div>
                <div className="evt-cal-dm-view-body">
                    {
                        _events.map((item, i) => {
                            return (
                                <EventItem event={item} isPast={item.isPast} key={i} isAdmin={isAdmin} />
                            )
                        })
                    }
                    <EmptyState isShown={(FakeData.listify(_events).length === 0) ? true : false} text={"No Events were found for " + month + ", " + year + "!"} icon="event" />
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/GroupEvents.jsx